import { searchText, type RawSearch } from "./search";

/** What a sign-in or sign-up page reads from its address. */
export function signInDeps(search: RawSearch) {
  return {
    returnTo: searchText(search, "returnTo"),
    method: searchText(search, "method"),
    sent: searchText(search, "sent"),
    error: searchText(search, "error"),
    reset: searchText(search, "reset") === "1",
  };
}

/** Where a recovery returns the member: a path on this site (with its query), or Home. */
export function recoveryTarget(returnTo: string) {
  const origin = "https://site.invalid";
  const resolved = new URL(
    returnTo.startsWith("/") && !returnTo.startsWith("//") && !returnTo.includes("\\")
      ? returnTo
      : "/",
    origin,
  );
  return resolved.origin === origin ? resolved.pathname + resolved.search : "/";
}
